__turbopack_context__.v({
  "button": "heroV2-carousel-module-scss-module__PVTota__button",
  "button-left": "heroV2-carousel-module-scss-module__PVTota__button-left",
  "button-right": "heroV2-carousel-module-scss-module__PVTota__button-right",
  "carousel": "heroV2-carousel-module-scss-module__PVTota__carousel",
  "chevron": "heroV2-carousel-module-scss-module__PVTota__chevron",
  "container": "heroV2-carousel-module-scss-module__PVTota__container",
  "nextArrow": "heroV2-carousel-module-scss-module__PVTota__nextArrow",
  "prevArrow": "heroV2-carousel-module-scss-module__PVTota__prevArrow",
});
